import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
import { cn } from '@core/utils';
const SkeletonGridRow = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <li className={cn("flex gap-24 overflow-hidden")}><Skeleton className="size-48 shrink-0 rounded-small" /><Skeleton className="size-48 shrink-0 rounded-small" /><Skeleton className="size-48 shrink-0 rounded-small" /><Skeleton className="size-48 shrink-0 rounded-small" /><Skeleton className="size-48 shrink-0 rounded-small" /><Skeleton className="size-48 shrink-0 rounded-small" /><Skeleton className="size-48 shrink-0 rounded-small" /><Skeleton className="size-48 shrink-0 rounded-small" /><Skeleton className="size-48 shrink-0 rounded-small" /><Skeleton className="size-48 shrink-0 rounded-small" /><Skeleton className="size-48 shrink-0 rounded-small" /></li>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const SkeletonListItem = () => {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cn("flex grow items-center gap-16");
    t1 = <Skeleton className="size-104 rounded-xlarge" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <li className={t0}>{t1}<div className="flex grow flex-col gap-8"><Skeleton className="h-42 w-full rounded-xxsmall" /><Skeleton className="h-42 w-2/3 rounded-xxsmall" /></div></li>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export const MobileSkeletonCover = t0 => {
  const $ = _c(9);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("z-10 flex size-full flex-col bg-[#767676] py-8", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mx-20 mb-8 flex items-center gap-12"><Skeleton className="size-36 rounded-xsmall" /><Skeleton className="h-27 w-100 rounded-xxsmall" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="px-20"><Skeleton className="mb-24 h-120 w-full rounded-large" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ul className="mb-36 flex flex-col gap-24 pl-20"><SkeletonGridRow /><SkeletonGridRow /></ul>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Skeleton className="mb-16 h-30 w-214 rounded-xxsmall" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="px-20">{t5}<ul className="flex flex-col gap-16"><SkeletonListItem /><SkeletonListItem /><SkeletonListItem /><SkeletonListItem /><SkeletonListItem /></ul></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t1) {
    t7 = <div className={t1}>{t2}{t3}{t4}{t6}</div>;
    $[7] = t1;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};